import React, { useEffect, useState } from 'react'
import { Page, Document, StyleSheet, Table, TableRow, TableCell, Text,View,Font } from '@react-pdf/renderer';
import { postInformacionEmpresa } from '../../../services/PaginaRuta'
import { HoraActual, fechaActual,calcularEdad } from '../../../hooks/UseDate'

// Registro de fuente personalizada
Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
  ]
})

const styles = StyleSheet.create({
    table: { 
      display: "table", 
      width: "auto", 
      borderStyle: "none", 
      //borderWidth: 1, 
      //borderRightWidth: 0, 
      // borderBottomWidth: 0 
    }, 
    tableRow: { 
      //margin: "auto", 
      flexDirection: "row" 
    }, 
    tableCol: { 
      width: "16.6%", 
      borderStyle: "none", 
      //borderWidth: 1, 
      //borderLeftWidth: 0, 
      //borderTopWidth: 0 
    }, 
    tableCell: { 
      width: "10%",
      padding: '3px',
      //flexGrow: 1,
      //margin: "auto", 
      //marginTop: 2, 
      fontSize: 7 
    },
    body:{
      padding: '10px'
    },
    tableCellLarge:{
      width: "50%",
      padding: '3px',
      //flexGrow: 1,
      //margin: "auto", 
      //marginTop: 2, 
      fontSize: 7 
    },
    left: {
      flex: 1,
      textAlign: 'left',
      fontSize: 9
    },
    right: {
      flex: 1,
      textAlign: 'right',
      fontSize: 9
    },    
    textBlock: {
      marginBottom: 2,
    },
    bold:{
      fontFamily: 'Open Sans',
      fontWeight: 600
    },
  });

const ModalPDFReimprimirDespachos = ({infoPDFReimprimirDespacho,dataUserPDF,usuarioEntrega,dataUser,usuarioRecibe}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [informacionEmpresa,setinformacionEmpresa]=useState([])
    useEffect(()=>{
        const datosEmpresa={
            "EMPCOD":usuarioInfo.Empresa,
            "MCDpto":usuarioInfo.Sede
        }
        postInformacionEmpresa(datosEmpresa).then((res)=>{
            console.log(res.data,'info empresa')
            setinformacionEmpresa(res.data[0])
        })
    },[])
  return (
    <Document>
        <Page size='A4' style={{padding: '10px' }}>
            <View>
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px', fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.EmpRazSoc}</Text>            
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.EmpNit}</Text>
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 600}}>{dataUser.DSmTpoTrn === 'DS'? 'DESPACHADO':(dataUser.DSmTpoTrn === 'DA'? 'DESPACHO ANULADO':(dataUser.DSmTpoTrn === 'CA'? 'DEVOLUCIÓN':(dataUser.DSmTpoTrn === 'DV'? 'DEVOLUCIÓN':null)))} DE PRODUCTOS</Text>
                <Text style={{ fontSize: 8,padding: '2px'}}><Text style={styles.bold}>Fecha:</Text> {fechaActual()}</Text>
                <Text style={{ fontSize: 8}}><Text style={styles.bold}>Hora:</Text> {HoraActual()}</Text>
                <Text style={{ fontSize: 8,padding: '2px'}}><Text style={styles.bold}>PACIENTE:</Text> {dataUserPDF.HISTipDoc? dataUserPDF.HISTipDoc:null} {dataUserPDF.HISCKEY? dataUserPDF.HISCKEY:null} {dataUserPDF.HClNomPac? dataUserPDF.HClNomPac.trim():null}        <Text style={styles.bold}>SEXO:</Text> {dataUserPDF.HISCSEX? dataUserPDF.HISCSEX:null}      <Text style={styles.bold}>EDAD:</Text> {dataUserPDF.HISCFNAC? calcularEdad(dataUserPDF.HISCFNAC.split(" ")[0]):null} Años</Text>
                <Text style={{ fontSize: 8,padding: '2px'}}><Text style={styles.bold}>FOLIO:</Text> {dataUser.HISCSEC?dataUser.HISCSEC:null} </Text>
                {/* <Text style={styles.bold}>PABELLON:</Text> {dataUserPDF.TFcNomPab? dataUserPDF.TFcNomPab.trim():null} {dataUserPDF.TFcCodCam? dataUserPDF.TFcCodCam:null}  */}
                {/* <Text style={{ fontSize: 8,padding: '2px'}}><Text style={styles.bold}>SERVICIO:</Text> {dataUserPDF.ClaPro? (dataUserPDF.ClaPro === '1'? 'Ambulatorio':(dataUserPDF.ClaPro === '2'? 'Hospitalización':(dataUserPDF.ClaPro === '3'? 'Urgencias':(dataUserPDF.ClaPro === '4'? 'Tratamiento especial':(dataUserPDF.ClaPro === '5'? 'Triage':(dataUserPDF.ClaPro === '6'? 'Refacturacion ambulatoria':(dataUserPDF.ClaPro === '7'?'Refactorizacion hospitalizacion':(dataUserPDF.ClaPro === '8'? 'Refactorizacion urgencias':null)))))))):null}                                 <Text style={styles.bold}>EMPRESA:</Text> {dataUserPDF.TFNomCto? dataUserPDF.TFNomCto:null}</Text> */}
                <Text style={{marginTop: 2, borderTop: '1pt solid #000', marginTop: 4, padding: '5px'}}/>
            </View>
            <View  style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={styles.tableCell}>
                        <Text style={styles.bold}>Codigo</Text> 
                    </View>
                    <View style={styles.tableCellLarge}> 
                        <Text  style={styles.bold}>Descripción</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                        <Text  style={styles.bold}>Estado</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Bodega</Text> 
                  </View> 
                  {/* <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Hora Fecha Despacho</Text> 
                  </View>  */}
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Cantidad solicitada</Text> 
                  </View>                  
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Cantidad despachada</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Cantidad devuelta</Text> 
                  </View> 
                  {/* <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Documento</Text> 
                  </View>  */}
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>Tipo despacho</Text> 
                  </View>                  
                </View>
                <View style={{ borderTop: '1pt solid #ccc', marginTop: 4 }} />
                {
                  infoPDFReimprimirDespacho.map((item, index) => (
                    <View key={index}>
                      <View style={styles.tableRow}>
                        <View style={styles.tableCell}> 
                          <Text>{item.MSRESO}</Text> 
                        </View> 
                        <View style={styles.tableCellLarge}> 
                          <Text>{item.MSNomG ? item.MSNomG.trim() : null}</Text> 
                          <Text>Forma: {item.FSmDscUMd ? item.FSmDscUMd.trim() : null}, Conc: {item.CncDes ? item.CncDes.trim() : null}</Text> 
                        </View> 
                        <View style={styles.tableCell}> 
                          <Text>{item.DSmTpoTrn === 'DS'? 'Despachado':(item.DSmTpoTrn === 'DA'? 'Despacho Anulado':(item.DSmTpoTrn === 'CA'? 'Cancelado':(item.DSmTpoTrn === 'DV'? 'Devolución':null)))}</Text> 
                        </View> 
                        <View style={styles.tableCell}> 
                          <Text>{item.DsBodSal}</Text> 
                        </View> 
                        {/* <View style={styles.tableCell}> 
                          <Text>{item.DSmFHrMov}</Text> 
                        </View>  */}
                        <View style={styles.tableCell}> 
                          <Text>{item.DSmCntDsp}</Text> 
                        </View> 
                        <View style={styles.tableCell}> 
                          <Text>{item.DSmCntDes}</Text> 
                        </View>       
                        <View style={styles.tableCell}> 
                          <Text>{item.DSmCntDev}</Text> 
                        </View>                       
                        {/* <View style={styles.tableCell}> 
                          <Text>{item.DSCodDoc}-{item.DsNumDoc}</Text> 
                        </View> */}
                        <View style={styles.tableCell}> 
                          <Text>{item.DsmTipDsp === 'P' ? 'Propios' : null}</Text> 
                        </View>
                      </View>
                      {/* Aquí agregamos la línea debajo de cada fila */}
                      <View style={{ borderTop: '1pt solid #ccc', marginTop: 4 }} />
                    </View>
                  ))
                }

            </View>
            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between' }}>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                  <View style={styles.left}>
                      {/* <Text style={{ borderBottomWidth: 1, borderBottomColor: 'black', marginBottom: 5, }}/> */}
                      <Text style={styles.textBlock}>{usuarioEntrega.AUsrDsc? usuarioEntrega.AUsrDsc:null }</Text>
                      <View style={{ borderTop: '1pt solid #ccc', marginTop: 4,width: '95%', }} />
                      <Text style={styles.textBlock}>Quien Entrega</Text>
                      <Text style={styles.textBlock}>{usuarioEntrega.AUsrId? usuarioEntrega.AUsrId:null}</Text>
                      <Text>CC</Text>
                  </View>
                  <View style={styles.right}>
                      {/* <Text style={{ borderBottomWidth: 1, borderBottomColor: 'black', marginBottom: 5, }}/> */}
                      <Text style={styles.textBlock}>{usuarioRecibe.AUsrDsc? usuarioRecibe.AUsrDsc:null}</Text>
                      <View style={{ borderTop: '1pt solid #ccc', marginTop: 4,width: '100%', }} />
                      <Text style={styles.textBlock}>Quien Recibe</Text>
                      <Text style={styles.textBlock}>{usuarioRecibe.AUsrId? usuarioRecibe.AUsrId:null}</Text>
                      <Text>CC:</Text>
                  </View>
              </View>
              <View style={{ justifyContent: 'flex-end', marginBottom: 20 }}>
                  <Text style={{ fontSize: 10, textAlign: 'center', padding: '5px' }}>*** FIN DEL REPORTE ***</Text>
              </View>
          </View>
        </Page>
    </Document>
  )
}

export default ModalPDFReimprimirDespachos